import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    status: {},
    error: null,
    loading: true,
};

export const postResult = createAsyncThunk(
    "FaceTec/postResult",
    async ({ data }, thunkAPI) => {
        const headers = {
            "api-version": "v1",
            "Ocp-Apim-Subscription-Key": "08ed34ad38d34939ba9888480eba417d",
        };
        let url = `${process.env.REACT_APP_PALIDIN_ENDPOINT_DEV}api/v2/scan/process?accessToken=${data?.token}`;

        try {
            const response = await axios.post(url, { headers });

            if (response?.data) {
                return {
                    status: response?.data,
                };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: error.response.data });
        }
    }
);


export const faceTecSlice = createSlice({
    name: "FaceTec",
    initialState,
    reducers: {
        reset: (state) => {
            return initialState;
        },
    },

    extraReducers: (builder) => {
        builder.addCase(postResult.fulfilled, (state, action) => {
            state.status = action.payload?.status;
        });
        builder.addCase(postResult.rejected, (state, action) => {
            state.status = initialState.status;
        });
    },
});

export const { reset } = faceTecSlice.actions;
